// test2895
(2895 && 0);
